import { ProductContainerData } from "./ProductContainer.js";

const DownloadLink = (link: string, label: string) => `
    <a clicktracking="off" href="${link}" target="_blank" class="product-list-container--link">
      <img style="width: 20px;vertical-align: middle;" src="https://stockhide.s3.amazonaws.com/reports-assets/download-white-icon.png" alt="download_icon" />
      <span style="vertical-align: middle;">${label}</span>
    </a>
`;

export const ProductListContainer = (
  events: ProductContainerData[],
  heading: string,
  pdfLink = "",
  csvLink = "",
  excelLink = "",
) => (`
  <div style="margin-bottom: 30px;">
    <div class="product-list-container--links-wrapper">
      <div class="product-list-container--links-title">
        <span style="font-size:18px;font-weight:600;color: #2D2D2D;">
          ${heading}
        </span>
      </div>
      <div class="product-list-container--links-actions">
        ${pdfLink ? DownloadLink(pdfLink, "PDF") : ""}
        ${csvLink ? DownloadLink(csvLink, "CSV") : ""}
        ${excelLink ? DownloadLink(excelLink, "EXCEL") : ""}
      </div>
    </div>
    <table style="width: 100%;border-radius: 10px;border-collapse: collapse;overflow: hidden;">
      <thead style="text-align: left;color: #505066;font-size: 14px;font-weight: 600;background: linear-gradient(60deg,rgba(3, 198, 230, 0.1) 0.63%,rgba(76, 99, 241, 0.1) 20.38%,rgba(110, 91, 234, 0.1) 40.13%,rgba(180, 104, 209, 0.1) 59.88%,rgba(217, 124, 194, 0.1) 79.62%,rgba(241, 137, 184, 0.1) 99.37%);">
        <tr>
          <th style="padding: 16px 10px 16px 10px;border: none;">Name</th>
          <th style="padding: 16px 10px 16px 10px;border: none;">Stock</th>
          <th style="padding: 16px 10px 16px 10px;border: none;" class="product-list-container--date-cell">Updated date & time*</th>
          <th style="padding: 16px 10px 16px 10px;border: none;">Action Taken</th>
        </tr>
      </thead>
      <tbody>
        ${events.map((event) => `
          <tr style="background: #FFF;border-top: 0.5px solid #DFE3E8;">
            <td style="padding: 16px 10px 16px 10px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" class="product-list-container--title-cell"><a clicktracking="off" href="${event.url}">${event.title}</a></td>
            <td style="padding: 16px 10px 16px 10px;text-align: center;">${event.stock}</td>
            <td style="padding: 16px 10px 16px 10px;text-wrap: nowrap;" class="product-list-container--date-cell">${event.updatedAt}</td>
            <td style="padding: 16px 21px 16px 10px; text-wrap: nowrap;">${event.action}</td>
          </tr>
        `).join("")}
      </tbody>
    </table>
    ${!events.length
    ? `<div style="padding:25px;text-align:center;background-color:#FBFBFB">
          <div style="padding:15px;margin: 0 auto;">
            <img style="display: inline-block;vertical-align: middle;" src="https://stockhide.s3.amazonaws.com/reports-assets/empty-mailbox.png" alt="empty" />
          </div>
          <div style="color: #2D2D2D;font-size:18px">Empty</div>
        </div>`
    : ""
  }
  </div>
`);